<template>
  <div class="reportBreadCrumb">
    <el-breadcrumb-item>管理报表</el-breadcrumb-item>
    <el-breadcrumb-item :class="{ active: item.url===$route.path }" :to="item.url" v-for="item in breadcrumbList" :key="item.id">{{item.name}}</el-breadcrumb-item>
  </div>
</template>
<script>
export default {
  data () {
    return {
      breadcrumbList: [],
      reportList: [
        { url: '/report/accountReport', name: '对账报表' }
      ]
    }
  },
  mounted () {
    this.setBreadCrumb(this.$route)
  },
  watch: {
    $route (to, from) {
      this.setBreadCrumb(to)
    }
  },
  methods: {
    setBreadCrumb (to) {
      let currentUrl = this.reportList.filter(item => item.url === to.path)
      if (!this.breadcrumbList.some(item => item.url === to.path)) {
        this.breadcrumbList = this.breadcrumbList.concat(currentUrl)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/breadcrumb/reportBreadCrumb.vue